import React, { createContext, useState } from 'react';
import contentState, {ContentStateType} from "../state/ContentState";


export type ContentContextType = {
    contentState: ContentStateType;
};

const ContentContext = React.createContext<ContentContextType>({
    contentState: contentState,
});

export default ContentContext;